import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import authStore from "../../store/authStore";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Stack,
} from "@mui/material";
import userActivePage from "../../store/userActivePage";
import { LoadingButton } from "@mui/lab";

const profileList = [
  {
    id: 1,
    pageName: "Edit Profile",
    to: "/user/manage-account",
    isActive: "manage-account",
  },
  {
    id: 2,
    pageName: "Address",
    to: "/user/address",
    isActive: "address",
  },
  {
    id: 3,
    pageName: "Coupon",
    to: "/user/coupon",
    isActive: "coupon",
  },
  {
    id: 4,
    pageName: "My Orders",
    to: "/user/my-orders",
    isActive: "my-orders",
  },
  {
    id: 5,
    pageName: "Reset Password",
    to: "/user/reset-password",
    isActive: "reset-password",
  },
  {
    id: 6,
    pageName: "Forgot Password",
    to: "/user/forgot-password",
    isActive: "forgot-password",
  },
];

const User = () => {
  const AuthStore = authStore();
  const navigate = useNavigate();
  const UserActivePage = userActivePage();

  const [open, setOpen] = useState(false);
  const [signOutLoading, setSignOutLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!signOutLoading) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (AuthStore.isLogged === false) {
      navigate("/");
    }
  }, [AuthStore.isLogged]);

  useEffect(() => {
    if (AuthStore.myUser) {
      AuthStore.fillAllEditFrom();
    }
  }, []);

  const signOutOnClick = async () => {
    setSignOutLoading(true);
    await AuthStore.signOut();
    setSignOutLoading(false);
    navigate("/", { replace: true });
  };

  return (
    <div style={{ transition: "all 0.5s ease", marginBottom: "50px" }}>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle id="alert-dialog-title">
          <p>Sign Out?</p>
        </DialogTitle>
        <DialogContent>
          <p>Are you sure want to sign out?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton loading={signOutLoading} onClick={signOutOnClick}>
            Sign Out
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Grid container spacing={1}>
        <Grid
          item
          xs={false}
          sm={false}
          md={3}
          lg={3}
          display={{ xs: "none", sm: "none", lg: "block", md: "block" }}
        >
          <Box
            component="div"
            sx={{
              transition: "all 0.5s ease",
              p: 2,
              width: "100%",
              position: "-webkit - sticky",
              position: "sticky",
              left: 0,
              top: "110px",
            }}
          >
            <Stack
              spacing={1}
              sx={{
                transition: "all 0.5s ease",
                background: "#fff",
                boxShadow: "0 2px 4px hsl(220, 10%, 94%)",
                borderRadius: "5px",
                p: 1,
                width: "100%",
              }}
            >
              {profileList.map((item) => (
                <MenuItem
                  key={item.id}
                  sx={{
                    transition: "all 0.5s ease",
                    background:
                      UserActivePage.isActive === item.isActive && "#f5f5f5",
                    borderRadius: "5px",
                    width: "100%",
                  }}
                >
                  <Link
                    to={item.to}
                    style={{ width: "100%", color: "#000" }}
                    replace
                  >
                    {item.pageName}
                  </Link>
                </MenuItem>
              ))}

              <Divider />
              <MenuItem
                sx={{
                  transition: "all 0.5s ease",
                  borderRadius: "5px",
                  width: "100%",
                }}
                onClick={handleClickOpen}
              >
                <p>SignOut</p>
              </MenuItem>
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={9} lg={9}>
          <Box component="div" sx={{ p: 2, transition: "all 0.5s ease" }}>
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default User;
